import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class TipBar extends AbstractProvidedClass {
    display(g) {
        g.stroke(0);
        g.strokeWeight(1);
        g.fill(255);
        g.rect(-1, g.height - TIP_BAR_HEIGHT, g.width, TIP_BAR_HEIGHT + 1);
        g.noStroke();
        g.textSize(14);
        g.fill(0);
        g.textAlign(g.LEFT, g.BOTTOM);
        g.text(this.tools.currentTool.getTips(), 10, g.height - 2);
    }
}
